import React from "react"
import { Container, Typography } from "@mui/material"
import styled from "styled-components"

interface GenericNoticeProps {
    title: React.ReactNode
    message?: React.ReactNode
    children: React.ReactNode
}

const StyledContainer = styled(Container)`
    margin-top: ${({ theme }) => theme.spacing(10)};
    display: flex;
    flex-direction: column;
    gap: 1rem; 
    align-items: center;
`

export default function GenericNotice({ title, message, children }: GenericNoticeProps) {
    return (
        <StyledContainer>
            <Typography variant="h6">{title}</Typography>
            <Typography>{message ? message : ''}</Typography>
            {children}
        </StyledContainer>
    )
}
